import React from "react";
import Logo from "./assets/logo.svg";
import UnderConstruction from "./assets/construction.svg";

const App = () => {
  return (
    <div className="h-screen flex flex-col">
      {/* Header */}
      <div className="px-4 py-4">
        <img src={Logo} alt="logo" className="h-8 w-auto" />
      </div>

      {/* Main content - using flex-grow to take available space */}
      <div className="flex-grow flex flex-col justify-center items-center px-4">
        <img
          src={UnderConstruction}
          alt="Under Construction"
          className="w-auto h-auto max-w-full max-h-[65vh]"
        />
        <h2 className="mt-2 text-xl md:text-2xl text-gray-200 text-center font-bold">
          Our website is under construction.
        </h2>
        <a
          href="mailto:info@huemono.com"
          title="info@huemono.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white mt-1 text-lg md:text-xl"
        >
          info@huemono.com
        </a>
      </div>

      {/* Footer */}
      <div className="px-4 py-4">
        <footer className="flex flex-col sm:flex-row-reverse items-center sm:items-baseline justify-between gap-2 text-gray-200">
          {/* Social media buttons */}
          <div className="flex justify-center gap-6 text-xl">
            <a
              href="https://www.linkedin.com/company/huemono/"
              title="huemono"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white"
            >
              <i className="fa-brands fa-linkedin" />
            </a>
            <a
              href="https://www.instagram.com/huemono24/"
              title="huemono"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white"
            >
              <i className="fa-brands fa-instagram" />
            </a>
            <a
              href=""
              title="huemono"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white"
            >
              <i className="fa-brands fa-facebook" />
            </a>
          </div>

          {/* Copyright */}
          <div className="text-center sm:text-left">
            <a
              href=""
              title="huemono"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white font-bold"
            >
              Huemono
            </a>
            <span className="ml-1">
              &copy; Copyright 2025. All rights reserved.
            </span>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default App;
